import { render, staticRenderFns } from "./SickLeaveBalanceEditModal.vue?vue&type=template&id=51a0c306&scoped=true&"
import script from "./SickLeaveBalanceEditModal.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveBalanceEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a0c306",
  null
  
)

export default component.exports